import { GoBackHeaderTitle } from "components";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useGetCategoryById } from "modules/categories";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { UsageGuideEditor } from "../UsageGuideEditor";

import styles from "./CategoryUsageGuide.module.scss";

const CategoryUsageGuide = () => {
  const { t } = useTranslation();
  const { categoryId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const { category } = useGetCategoryById(categoryId);

  // The categories tree keeps its selection in the query string, so going back
  // to the exact column the admin came from is just a matter of replaying it.
  const goBack = () =>
    navigate({
      pathname: "/categories",
      search: state?.categoriesSearch ?? ""
    });

  return (
    <ContentLayout
      title={
        <GoBackHeaderTitle
          title={t("How to use + FAQ")}
          onGoBack={goBack}
        />
      }
    >
      <BoxShadowLayout className={styles.categoryGuide}>
        <UsageGuideEditor
          scope={{ categoryId }}
          header={
            <p className={styles.categoryGuide_scope}>
              {t("Category guide")}
              <span className={styles.categoryGuide_scopeName}>
                {category?.name}
              </span>
            </p>
          }
        />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default CategoryUsageGuide;
